import { toast } from 'react-toastify'
import { FIREBASE_ERROR_MESSAGES } from '../data/constants'

export const handleFirebaseErrors = (error: any) => {
  console.log(`---error---`,error)
  toast.error(FIREBASE_ERROR_MESSAGES[error.code] || `Error`)
}
